import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const MinMaxInMultipleDegree = () => (
  <QPhototModuleSubtopic
    title="Min Max in multiple degree"
    videos={[
      "https://www.youtube.com/embed/j5VGo1n8KBY",
      "https://www.youtube.com/embed/kQSF_7dp6SA"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_34.jpeg"
        },
        {
            image:"/cal_35.jpeg"
        },
        {
            image:"/cal_36.jpeg"
        },
        {
            image:"/cal_37.jpeg"
        },
        {
            image:"/cal_38.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default MinMaxInMultipleDegree;
